<template>
    <BasicLayouts>
        <body>
        <div class="container-table">
        <h1>Resumen del Carrito</h1>
        <table class="ui celled table" v-if="products">
            <thead>
                <tr>
                    <th>Producto</th>
                    <th>Cantidad</th>
                    <th>Precio</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in products" :key="product.id">
                    <td>{{ product.name }}</td>
                    <td>{{ product.quantity }}</td>
                    <td>{{ product.price }}$</td>
                    <td style="text-align:center">
                        <i class="close icon" @click="deleteAllProductCart(product.id)"></i>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>Total:</td>
                    <td colspan="2">{{ getTotal() }}$</td>
                </tr>
            </tbody>
        </table>
        <button class="ui button primary fluid">
            Generar Pedido
        </button>

        <h3 v-if="!products">No tienes productos en el carro</h3>
        </div>
    </body>
    </BasicLayouts>
</template>

<script>
import { ref,  watchEffect } from 'vue';
import { getProductsCartApi, deleteAllProductCartApi } from '../api/cart';
import BasicLayouts from '../layouts/BasicLayouts.vue';
export default {
    name:'Car',
    components:{
        BasicLayouts,
    },
    setup(){
        let products=ref(null);
        let reloadCart=ref(false);

        watchEffect(async ()=>{
            reloadCart.value;
            const response= await getProductsCartApi();
            products.value=response;
        });

        const getTotal=()=>{
            let totalTemp=0;
            products.value.forEach((product)=>{
                totalTemp += product.price * product.quantity;
            });
            return totalTemp.toFixed(2);
        };

        const deleteAllProductCart= (idProduct)=>{
            deleteAllProductCartApi(idProduct);
            reloadCart.value= !reloadCart.value;
        };
        return{
            products,
            getTotal,
            deleteAllProductCart,
        };
    },
};
</script>

<style scoped>
h1{
    border-radius: 10rem;
    background-color: red;
    color: yellow;
    text-align: center;
}
.container-table{
    padding: 40px;
    margin-bottom: 120px;
}
.ui.button.primary.fluid{
    margin: auto;
    width: 40%;
}
body{
    background-image: url(../assets/fondo_pagina_web.png); /*ruta de la imagen ../ pra que sea desde arriba*/    
    background-repeat: no-repeat;  /* para que no se repita la imagen */
    background-position: center center;/*posicionar background*/
    background-size: cover;/* ajustar imagen a contenedor*/
    background-attachment: fixed;
}
</style>